import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';
import classNames from './Icon.module.scss';

export const AiIcon = ({
  style,
  grow,
  width = 24,
  height = 24,
}: SVGIconProps) => {
  return (
    <Center
      h={height}
      w={width}
      style={style}
      classNames={classNames}
      data-grow={grow}
    >
      <img
        style={{ height: '100%', width: '100%' }}
        src="/images/ai-icon.png"
      />
    </Center>
  );
};
